<ng-container *ngIf="showDefaultRowButtons">
    <tt-grid-button
        *ngIf="showStandaloneGotoButton"
        ttContext="row"
        ttType="staticgoto"
        ttIcon="fas fa-chevron-right"
        ttKind="primary"
        [grid]="params?.grid"
        [node]="params?.node"
        [colDef]="params?.colDef"
    ></tt-grid-button>
    <tt-grid-button
        *ngIf="showStandaloneNewTabButton"
        ttContext="row"
        ttType="staticgoto"
        ttIcon="fas fa-window-restore"
        ttKind="primary"
        ttForceNewTab="true"
        [grid]="params?.grid"
        [node]="params?.node"
        [colDef]="params?.colDef"
    ></tt-grid-button>
    <tt-grid-button
        *ngIf="params?.specialFunc?.duplicate && params?.node?.data"
        ttIcon="fas fa-clone"
        ttKind="primary"
        [ttTooltipText]="params?.grid?.translations?.['duplicate_row'] ?? ''"
        ttTranslateTooltipText="false"
        (ttClick)="duplicateRow($event)"
    ></tt-grid-button>
    <tt-grid-button
        *ngFor="let button of buttons"
        [ttId]="button.name"
        [ttText]="button.text ?? ''"
        [ttTranslateText]="button.translate ?? true"
        [ttTooltipText]="button.tooltip ?? ''"
        [ttTranslateTooltipText]="button.translateTooltip ?? true"
        [ttIcon]="button.icon ?? ''"
        [ttType]="button.type"
        [ttKind]="getButtonKind($any(button))"
        [ttReadOnClose]="button.read_on_close"
        [ttRebindOnClose]="button.rebind_on_close"
        [ttGoto]="button.state"
        [ttGotoParms]="button.state_params"
        [ttP2DatataskKeyno]="button.p2_datatask_keyno"
        [ttModalComponent]="button.component"
        [ttModalSize]="button.modal_size"
        [ttModalHeight]="button.modal_height || undefined"
        [ttModalWidth]="button.modal_width || undefined"
        [ttSaveSelectedRows]="button.save_selected_rows"
        ttContext="row"
        [grid]="params?.grid"
        [node]="params?.node"
        [colDef]="params?.colDef"
        [ttDisabled]="button._disabled"
        [ttItems]="$any(button).buttons"
        [ttOverflowItemTextFallback]="getButtonText"
        (ttClick)="onRowButtonClick($any(button), $event)"
    ></tt-grid-button>
    <tt-grid-button *ngIf="hasSpecialFuncEdit" ttIcon="fas fa-pencil" ttKind="primary" (ttClick)="editRow($event)"></tt-grid-button>
</ng-container>
<ng-container *ngIf="showGroupNodeButtons">
    <tt-grid-button
        *ngFor="let button of groupButtons"
        [ttId]="button.name"
        [ttText]="button.text ?? ''"
        [ttTranslateText]="button.translate ?? true"
        [ttTooltipText]="button.tooltip ?? ''"
        [ttTranslateTooltipText]="button.translateTooltip ?? true"
        [ttIcon]="button.icon ?? ''"
        [ttType]="button.type"
        [ttKind]="getButtonKind($any(button))"
        [ttReadOnClose]="button.read_on_close"
        [ttRebindOnClose]="button.rebind_on_close"
        [ttGoto]="button.state"
        [ttGotoParms]="button.state_params"
        [ttP2DatataskKeyno]="button.p2_datatask_keyno"
        [ttModalComponent]="button.component"
        [ttModalSize]="button.modal_size"
        [ttModalHeight]="button.modal_height || undefined"
        [ttModalWidth]="button.modal_width || undefined"
        [ttSaveSelectedRows]="button.save_selected_rows"
        ttContext="rowGroup"
        [grid]="params?.grid"
        [node]="params?.node"
        [colDef]="params?.colDef"
        [ttDisabled]="button._disabled"
        [ttItems]="$any(button).buttons"
        [ttOverflowItemTextFallback]="getButtonText"
        (ttClick)="onRowGroupButtonClick($any(button), $event)"
    ></tt-grid-button>
</ng-container>
